var cifNl = ["301 201", "<g fill='none'><path fill='#21468B' d='M.5.5h300v200H.5z'/><path fill='#FFF' d='M.5.5h300v133.333H.5z'/><path fill='#AE1C28' d='M.5.5h300v66.667H.5z'/></g>"];

export { cifNl };
